import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {
    formAltaMono_updateStore({ commit, dispatch }, form) {

        const formData = new FormData()

        Object.keys(form).forEach(key => {

            if (form[key] !== null && form[key] !== '') {
                formData.append(key, form[key])
            }

        })

        return new Promise((resolve, reject) => {

            axios.post(
                Config.apiPath + 'form-alta-mono/update-store',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error.response)
                })

        })
    },
    fromAltaMono_getByIdUser({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'form-alta-mono/get-by-id-user/'+form.idUser)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    }
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};